import { render, staticRenderFns } from "./billsReceivable.vue?vue&type=template&id=23a37315&scoped=true"
import script from "./billsReceivable.vue?vue&type=script&lang=js"
export * from "./billsReceivable.vue?vue&type=script&lang=js"
import style0 from "./billsReceivable.vue?vue&type=style&index=0&id=23a37315&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23a37315",
  null
  
)

export default component.exports